var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "23px",
    viewBox: "0 0 29 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fill",
    id: "All-Categories",
    transform: "translate(-25.000000, -197.000000)",
    fill: "#F05F4B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(25.000000, 197.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,7.2042 L11.04,7.2042 L11.04,2.0002 L2,2.0002 L2,7.2042 Z M12.04,9.2042 L1,9.2042 C0.448,9.2042 0,8.7562 0,8.2042 L0,1.0002 C0,0.4482 0.448,0.0002 1,0.0002 L12.04,0.0002 C12.592,0.0002 13.04,0.4482 13.04,1.0002 L13.04,8.2042 C13.04,8.7562 12.592,9.2042 12.04,9.2042 L12.04,9.2042 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,19.0552 L11.04,19.0552 L11.04,13.8512 L2,13.8512 L2,19.0552 Z M12.04,21.0552 L1,21.0552 C0.448,21.0552 0,20.6072 0,20.0552 L0,12.8512 C0,12.2992 0.448,11.8512 1,11.8512 L12.04,11.8512 C12.592,11.8512 13.04,12.2992 13.04,12.8512 L13.04,20.0552 C13.04,20.6072 12.592,21.0552 12.04,21.0552 L12.04,21.0552 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.817,7.2042 L26.857,7.2042 L26.857,2.0002 L17.817,2.0002 L17.817,7.2042 Z M27.857,9.2042 L16.817,9.2042 C16.265,9.2042 15.817,8.7562 15.817,8.2042 L15.817,1.0002 C15.817,0.4482 16.265,0.0002 16.817,0.0002 L27.857,0.0002 C28.41,0.0002 28.857,0.4482 28.857,1.0002 L28.857,8.2042 C28.857,8.7562 28.41,9.2042 27.857,9.2042 L27.857,9.2042 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.817,19.0552 L26.857,19.0552 L26.857,13.8512 L17.817,13.8512 L17.817,19.0552 Z M27.857,21.0552 L16.817,21.0552 C16.265,21.0552 15.817,20.6072 15.817,20.0552 L15.817,12.8512 C15.817,12.2992 16.265,11.8512 16.817,11.8512 L27.857,11.8512 C28.41,11.8512 28.857,12.2992 28.857,12.8512 L28.857,20.0552 C28.857,20.6072 28.41,21.0552 27.857,21.0552 L27.857,21.0552 Z",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIc);
export default __webpack_public_path__ + "static/media/windows-ic.647bf30e47b96a27069d24a933c06839.svg";
export { ForwardRef as ReactComponent };